import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MinatBakatDiri = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const location = useLocation();
  const { user } = location.state;

  const [ability] = useState([
    'Public Speaking',
    'Karya Tulis Ilmiah',
    'Riset',
    'Tidak ada satupun di atas',
  ]);

  const [talentsCheck, setTalentsCheck] = useState(true);
  const [talentsOthers, setTalentsOthers] = useState('');
  const [talents] = useState([
    'Menyanyi',
    'Menari',
    'Membawakan Acara (MC)',
    'Membawakan Acara (Moderator)',
    'Menerjemakan ke dalam Bahasa Inggris',
    'Membuat Karya Tulis Ilmiah',
    'Memotret/Fotografi',
    'Membuat Desain',
    'Mengedit Video',
    'Make-Up',
    'Melukis/Menggambar',
    'Story Telling',
    'Pidato',
    'Stand Up Comedy',
  ]);

  const [musicsCheck, setMusicsCheck] = useState(true);
  const [musicsOthers, setMusicsOthers] = useState('');
  const [musics] = useState([
    'Alat Musik Tradisional',
    'Gitar',
    'Gitar Akustik',
    'Piano',
    'Violin/Biola',
    'Drum',
    'Flute/seruling',
    'Saxophone',
    'Keyboard',
    'Alat Musik Elektrik',
    'Cello',
    'Harmonika',
    'Akordion',
    'Ukulele',
    'Trompet',
    'Tidak bisa alat musik',
  ]);

  const [bcfAct, setBcfAct] = useState([
    'Seminar Nasional',
    'Seminar Internasional',
    'Ikatan Alumni Home of Leaders',
    'Magang Offline',
    'Magang Online',
    'Volunteer',
    'Penelitian',
    'Pengabdian kepada Masyarakat',
    'Indonesia Youth Sustainability Forum',
  ]);

  // Talents State Management

  const [selectedTalents, setSelectedTalents] = useState([]);
  const onHandleSelectedTalents = (e) => {
    const { value } = e.target;
    let newArray = [...selectedTalents, value];
    if (selectedTalents.includes(value)) {
      newArray = newArray.filter((talent) => talent !== value);
    }
    setSelectedTalents(newArray);
  };

  const onHandleTalentChecked = (e) => {
    const { checked } = e.target;
    setTalentsCheck(!checked);
    let newArray = [...selectedTalents];
    if (checked === true) {
      if (selectedTalents.includes(talentsOthers)) {
        newArray = newArray.filter((talent) => talent !== talentsOthers);
      }
    }
    setSelectedTalents(newArray);
  };

  const onHandleOtherSaveTalents = () => {
    setTalentsCheck(true);
    setSelectedTalents([...selectedTalents, talentsOthers]);
  };

  // Ability State Management

  const [selectedAbility, setSelectedAbility] = useState([]);
  const onHandleSelectedAbility = (e) => {
    const { value } = e.target;
    let newArray = [...selectedAbility, value];
    if (selectedAbility.includes(value)) {
      newArray = newArray.filter((ability) => ability !== value);
    }
    setSelectedAbility(newArray);
  };

  // Musics State Management

  const [selectedMusics, setSelectedMusics] = useState([]);
  const onHandleSelectedMusics = (e) => {
    const { value } = e.target;
    let newArray = [...selectedMusics, value];
    if (selectedMusics.includes(value)) {
      newArray = newArray.filter((music) => music !== value);
    }
    setSelectedMusics(newArray);
  };

  const onHandleMusicsChecked = (e) => {
    const { checked } = e.target;
    setMusicsCheck(!checked);
    let newArray = [...selectedMusics];
    if (checked === true) {
      if (selectedMusics.includes(musicsOthers)) {
        newArray = newArray.filter((music) => music !== musicsOthers);
      }
    }
    setSelectedMusics(newArray);
  };

  const onHandleOtherSaveMusics = () => {
    setMusicsCheck(true);
    setSelectedMusics([...selectedMusics, musicsOthers]);
  };

  // BCF Activity State Management

  const [selectedBcfAct, setSelectedBcfAct] = useState([]);
  const onHandleSelectedBcfAct = (e) => {
    const { value } = e.target;
    let newArray = [...selectedBcfAct, value];
    if (selectedBcfAct.includes(value)) {
      newArray = newArray.filter((bcfAct) => bcfAct !== value);
    }
    setSelectedBcfAct(newArray);
  };

  useEffect(() => {
    setProfile(user);

    const splitOrEmpty = (value) => (value ? value.split(',') : ['']);

    setSelectedTalents(splitOrEmpty(user?.talent));
    setSelectedAbility(splitOrEmpty(user?.ability));
    setSelectedMusics(splitOrEmpty(user?.musicalInstrument));
    setSelectedBcfAct(splitOrEmpty(user?.activitiesBCF));
  }, []);

  const onHandleSubmit = () => {
    const mergedUser = { ...user, ...profile };

    const sanitize = (arr) => arr.filter((value) => value !== '').toString();

    const data = {
      ...mergedUser,
      talent: sanitize(selectedTalents),
      ability: sanitize(selectedAbility),
      musicalInstrument: sanitize(selectedMusics),
      activitiesBCF: sanitize(selectedBcfAct),
    };

    const requiredFields = {
      talent: 'Bakat Kosong!',
      descriptionSelectedTalent: 'Deskripsi Bakat Kosong!',
      activitiesBCF: 'Kegiatan BCF Kosong!',
      fiveYearAward: 'Penghargaan 5 Tahun Kosong!',
      cardSelfieId: 'Foto Diri ID Card Kosong!',
    };

    for (const [key, message] of Object.entries(requiredFields)) {
      if (!data[key]) return alert(message);
    }

    navigate('/app/profile/update/acivities', { state: { user: data } });
  };

  return (
    <>
      <div className="py-5 text-center">
        <h2>II. MINAT DAN BAKAT MAHASISWA</h2>
        <p className="lead">
          Bagian ini merupakan pendataan minat dan bakat yang dimiliki mahasiswa
          untuk bisa diwadahi melalui kegiatan-kegiatan yang BCF sediakan selama
          periode Magang/Praktikum/Volunteer maupun kesempatan setelah mahasiswa
          menjadi alumni di Ikatan Alumni BCF yang disebut Home of Leaders yang
          dapat dipelajari di sini: https://bit.ly/IkatanAlumniBCF2023 Isi
          bagian Minat dan Bakat dengan JUJUR dan BENAR!
        </p>
      </div>

      <div className="row g-5 mb-5">
        <div className="col-md-12 col-lg-8">
          <form className="needs-validation" noValidate="">
            <div className="row g-3">
              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <label htmlFor="address" className="form-label">
                      Bakat Apa yang Kamu Miliki? *
                    </label>
                    {talents.map((value, key) => (
                      <div className="form-check" key={key}>
                        <input
                          checked={selectedTalents?.includes(value)}
                          onChange={(e) => onHandleSelectedTalents(e)}
                          className="form-check-input"
                          type="checkbox"
                          value={`${value}`}
                          id={`check-${value}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`check-${value}`}
                        >
                          {value}
                        </label>
                      </div>
                    ))}
                    <div className="input-group mt-2">
                      <div className="input-group-text">
                        <input
                          checked={!talentsCheck}
                          onChange={(e) => onHandleTalentChecked(e)}
                          className="form-check-input mt-0"
                          type="checkbox"
                          value=""
                          aria-label="Checkbox for following text input"
                        />
                      </div>
                      <input
                        disabled={talentsCheck}
                        value={talentsOthers}
                        onChange={(e) => setTalentsOthers(e.target.value)}
                        type="text"
                        placeholder="Lainnya"
                        className="form-control"
                        aria-describedby="button-addon2"
                        aria-label="Text input with checkbox"
                      />
                      <button
                        disabled={talentsCheck}
                        onClick={() => onHandleOtherSaveTalents()}
                        className="btn btn-outline-secondary"
                        type="button"
                        id="button-addon2"
                      >
                        Simpan
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <label htmlFor="address" className="form-label">
                      Alat Musik Apa yang Dapat Kamu Mainkan?
                    </label>
                    {musics.map((music, key) => (
                      <div className="form-check" key={key}>
                        <input
                          checked={selectedMusics?.includes(music)}
                          onChange={(e) => onHandleSelectedMusics(e)}
                          className="form-check-input"
                          type="checkbox"
                          value={`${music}`}
                          id={`check-${music}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`check-${music}`}
                        >
                          {music}
                        </label>
                      </div>
                    ))}
                    <div className="input-group mt-2">
                      <div className="input-group-text">
                        <input
                          checked={!musicsCheck}
                          onChange={(e) => onHandleMusicsChecked(e)}
                          className="form-check-input mt-0"
                          type="checkbox"
                          value=""
                          aria-label="Checkbox for following text input"
                        />
                      </div>
                      <input
                        disabled={musicsCheck}
                        value={musicsOthers}
                        onChange={(e) => setMusicsOthers(e.target.value)}
                        type="text"
                        placeholder="Lainnya"
                        className="form-control"
                        aria-describedby="button-addon2"
                        aria-label="Text input with checkbox"
                      />
                      <button
                        disabled={musicsCheck}
                        onClick={() => onHandleOtherSaveMusics()}
                        className="btn btn-outline-secondary"
                        type="button"
                        id="button-addon2"
                      >
                        Simpan
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div
                    class="alert alert-primary d-flex align-items-center"
                    role="alert"
                  >
                    <div>
                      <p>
                        Pengisian Data tidak diperbolehkan menggunakan emoticon
                        seperti: (🙏🔥👌)
                      </p>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Deskripsikan Pengalaman terkait Bakat yang Kamu Miliki
                        (Contoh: pernah menyanyi rutin di kafe) *
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            descriptionSelectedTalent: e.target.value,
                          })
                        }
                        value={profile?.descriptionSelectedTalent}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Dalam kurun waktu 5 tahun terakhir, apakah kamu pernah
                        mendapatkan penghargaan yang berkaitan dengan Bakat yang
                        kamu miliki? (Contoh: Juara 1 menari tingkat RT) *
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            fiveYearAward: e.target.value,
                          })
                        }
                        value={profile?.fiveYearAward}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Kemampuan apa yang kamu miliki? *
                      </label>
                      {ability.map((value, key) => (
                        <div className="form-check" key={key}>
                          <input
                            checked={selectedAbility?.includes(value)}
                            onChange={(e) => onHandleSelectedAbility(e)}
                            className="form-check-input"
                            type="checkbox"
                            value={`${value}`}
                            id={`check-${value}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`check-${value}`}
                          >
                            {value}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Deskripsikan pengalaman terkait kemampuan yang kamu
                        pilih: (Opsional)
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            descriptionSelectedAbility: e.target.value,
                          })
                        }
                        value={profile?.descriptionSelectedAbility}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Apakah kamu pernah meraih penghargaan atau prestasi di
                        bidang tersebut? (Opsional)
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            awardSelectedAbility: e.target.value,
                          })
                        }
                        value={profile?.awardSelectedAbility}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Tuliskan prestasi atau pencapaian kamu dalam tiga tahun
                        terakhir *
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            achievementLastThreeYears: e.target.value,
                          })
                        }
                        value={profile?.achievementLastThreeYears}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <label htmlFor="address" className="form-label">
                      Kegiatan-kegiatan BCF Mana Saja yang Kamu Minati? *
                    </label>
                    {bcfAct.map((act, key) => (
                      <div className="form-check" key={key}>
                        <input
                          checked={selectedBcfAct?.includes(act)}
                          onChange={(e) => onHandleSelectedBcfAct(e)}
                          className="form-check-input"
                          type="checkbox"
                          value={`${act}`}
                          id={`check-${act}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`check-${act}`}
                        >
                          {act}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Foto Diri Mahasiswa untuk ID Card (Link Google Drive) *
                      </label>
                      <p>Berikut syarat foto:</p>
                      <ul>
                        <li>Foto dengan kualitas HD (1080x1350)</li>
                        <li>
                          Medium shot dengan white space di kanan dan kiri
                        </li>
                        <li>Tidak menggunakan Almamater</li>
                        <li>
                          Foto bisa menggunakan kemeja, batik, polos dan corak
                          apapun
                        </li>
                      </ul>
                    </div>
                    <div className="col-12">
                      <div class="d-flex justify-content-between">
                        <figure class="figure m-3">
                          <img
                            height={400}
                            src="https://firebasestorage.googleapis.com/v0/b/bcf-clp-app.appspot.com/o/update-profile%2Fexample-one.jpeg?alt=media&token=34d6de36-77dc-4877-b8ca-12cff38f7b11"
                            class="figure-img img-fluid rounded object-fit-cover"
                            alt="..."
                          />
                          <figcaption class="figure-caption text-end">
                            Contoh Perempuan
                          </figcaption>
                        </figure>
                        <figure class="figure">
                          <img
                            height={400}
                            src="https://firebasestorage.googleapis.com/v0/b/bcf-clp-app.appspot.com/o/update-profile%2Fexample-two.jpeg?alt=media&token=8bc08206-b6b3-467d-bc28-e15571e9daa0"
                            class="figure-img img-fluid rounded object-fit-cover"
                            alt="..."
                          />
                          <figcaption class="figure-caption text-end">
                            Contoh Laki Laki
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>
                  <input
                    onChange={(e) =>
                      setProfile({ ...profile, cardSelfieId: e.target.value })
                    }
                    value={profile?.cardSelfieId}
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={() => onHandleSubmit()}
              className="w-100 btn btn-primary btn-lg my-4"
              type="button"
            >
              Lanjut
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default MinatBakatDiri;
